import React from 'react';

const CrossIcon = ({size = 24}) => (
  <svg viewBox="0 0 10 10" width={size} height={size}>
    <path fill="#777" d="M0 1.41 1.4 0 9.9 8.48 8.48 9.9z"/>
    <path fill="#777" d="M10 1.41 8.59 0 .1 8.49l1.41 1.4z"/>
  </svg>
);

export default CrossIcon;
